export enum ClientProposalAction {
  RequestCasting = 1,
  RequestRevision = 2,
  AcceptProposal = 3,
  RefuseProposal = 4
}
